import type { LocaleCode } from "./locale-config";

const names: Partial<Record<LocaleCode, Record<string, string>>> = {
  "fa-ir": {
    vancouver: "ونکوور",
    burnaby: "برنابی",
    coquitlam: "کوکیتلام",
    surrey: "سوری",
    richmond: "ریچموند",
    "north-vancouver": "نورث ونکوور",
    "west-vancouver": "وست ونکوور",
    "new-westminster": "نیو وست‌مینستر",
    "port-coquitlam": "پورت کوکیتلام",
    "port-moody": "پورت مودی",
    "maple-ridge": "میپل ریج",
    delta: "دلتا",
    langley: "لنگلی",
    "white-rock": "وایت راک",
  },
  "ar-sa": {
    vancouver: "فانكوفر",
    burnaby: "بورنابي",
    coquitlam: "كوكويتلام",
    surrey: "سوري",
    richmond: "ريتشموند",
    "north-vancouver": "نورث فانكوفر",
    "west-vancouver": "ويست فانكوفر",
    "new-westminster": "نيو وستمنستر",
    "port-coquitlam": "بورت كوكويتلام",
    "port-moody": "بورت مودي",
    "maple-ridge": "ميبل ريدج",
    delta: "دلتا",
    langley: "لانغلي",
    "white-rock": "وايت روك",
  },
};

export function localizeAreaName(slug: string, fallback: string, locale: LocaleCode): string {
  return names[locale]?.[slug] ?? fallback;
}
